import { useNavigate } from "react-router-dom";

import { ROUTE_PATHS } from "@routes/routePath";

interface Args {
  draftArticleId: string;
}

export const useMovePublicationDetailPage = ({ draftArticleId }: Args) => {
  const navigate = useNavigate();

  const movePublicationDetailPage = () => {
    const pathname = ROUTE_PATHS.publicationFillInTable;
    const url = `${pathname}?id=${draftArticleId}`;

    navigate(url);
  };

  return {
    movePublicationDetailPage,
  };
};
